import { Link } from "react-router-dom";

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  linkTo?: string;
  linkLabel?: string;
}

export default function SectionHeading({ title, subtitle, linkTo, linkLabel = "查看全部" }: SectionHeadingProps) {
  return (
    <div className="mb-4 flex flex-wrap items-end justify-between gap-3">
      <div className="flex items-center gap-3">
        <span className="h-5 w-1 rounded-full bg-primary-500" aria-hidden="true" />
        <div>
          <h2 className="text-lg font-bold text-foreground-950 md:text-xl">{title}</h2>
          {subtitle ? <p className="mt-0.5 text-xs text-foreground-500 md:text-sm">{subtitle}</p> : null}
        </div>
      </div>
      {linkTo ? (
        <Link
          to={linkTo}
          className="flex items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-600 transition-colors duration-200 hover:text-primary-700"
        >
          {linkLabel}
          <i className="ri-arrow-right-s-line text-base" aria-hidden="true" />
        </Link>
      ) : null}
    </div>
  );
}